import React from "react";

/* text seen on top of the about section */
export function AboutText() {
  return (
    <div className="text-center">
      <h2 className="sm:text-5xl text-2xl font-bold mx-1">
        Trusted by developers across the world
      </h2>
      <p className="sm:text-3xl py-6 text-gray-500 px-5 sm:px-4 md:px-3 lg:px-2 xl:px-1">
        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Cumque
        perspiciatis qui, provident a hic nesciunt harum illum quae dolores.
        Inventore esse error ipsam illo repellat. Repellat libero perferendis
        neque laborum!
      </p>
    </div>
  );
}
